<template>
  <div id="form-creation-input-information">
    <Input
      class="scs-input"
      :error="errors.input.title"
      :initialValue="input.inputTitle"
      heading="Input Title"
      placeholder="Input Title"
      @scs-input="inputTitleInput"
    />
    <Select
      class="scs-input"
      :options="inputTypes"
      :formatter="formatter"
      heading="Input Type"
      @input="typeInput"
    />
    <Input
      class="scs-input"
      v-if="input.inputType === 'select'"
      :error="errors.input.optionQuantity"
      heading="Number of Options"
      placeholder="3"
      type="number"
      @scs-input="inputOptionQuantityInput"
    />
  </div>
</template>
<script>
import Input from "@/Components/Elements/Input.vue";
import Select from "@/Components/Elements/Select.vue";
export default {
  data() {
    return {
      initialType: undefined,
      inputTypes: [
        {
          display: "Text",
          inputValue: "text",
        },
        {
          display: "Number",
          inputValue: "number",
        },
        {
          display: "Phone Number",
          inputValue: "tel",
        },
        {
          display: "Email",
          inputValue: "email",
        },
        {
          display: "Color",
          inputValue: "color",
        },
        {
          display: "Select",
          inputValue: "select",
        },
        {
          display: "Text Area",
          inputValue: "textarea",
        },
      ],
    };
  },
  methods: {
    formatter(obj) {
      return obj.display;
    },
    typeInput(type) {
      this.$emit("input-type-input", type.inputValue);
    },
    inputTitleInput(value) {
      this.$emit("input-title-input", value);
    },
    inputOptionQuantityInput(int) {
      this.$emit("options-quantity-input", int);
    },
  },
  created() {
    this.initialType = this.inputTypes.find((x) => {
      return x.inputValue === this.input.inputType;
    });
  },
  components: {
    Input,
    Select,
  },
  emits: ["input-type-input", "input-title-input", "options-quantity-input"],
  props: ["input", "errors"],
};
</script>
<style scoped>
@media screen {
  #form-creation-input-information {
    min-height: 350px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-bottom: 30px;
  }

  .scs-input {
    width: 100%;
    margin: 10px;
  }
  @media (min-width: 800px) {
    .scs-input {
      width: 350px;
    }
  }
}
</style>
